import React from "react";
import { FaCheckCircle, FaTruck, FaBox, FaClock } from "react-icons/fa";

const TrackOrderModal = ({ isOpen, onClose, orders }) => {
  if (!isOpen) return null;

  const getStatusDetails = (status) => {
    switch (status) {
      case "pending":
        return {
          label: "Order Pending",
          color: "text-orange-500",
          bg: "bg-orange-100",
          icon: <FaClock />,
          progress: 25,
        };
      case "processing":
        return {
          label: "Processing",
          color: "text-blue-500",
          bg: "bg-blue-100",
          icon: <FaBox />,
          progress: 50,
        };
      case "shipped":
        return {
          label: "In Transit",
          color: "text-purple-500",
          bg: "bg-purple-100",
          icon: <FaTruck />,
          progress: 75,
        };
      case "delivered":
        return {
          label: "Delivered",
          color: "text-green-500",
          bg: "bg-green-100",
          icon: <FaCheckCircle />,
          progress: 100,
        };
      default:
        return {
          label: "Pending",
          color: "text-gray-500",
          bg: "bg-gray-100",
          icon: <FaClock />,
          progress: 10,
        };
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 backdrop-blur-sm overflow-y-auto">
      <div className="bg-white rounded-2xl w-full max-w-lg shadow-2xl overflow-hidden my-8">
        <div className="bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
          <div>
            <h2 className="text-xl font-bold text-gray-900">Track Orders</h2>
            <p className="text-sm text-gray-500 mt-1">Status of your scan gun requests</p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl mb-4"
          >
            &times;
          </button>
        </div>

        <div className="p-6 space-y-6 max-h-[60vh] overflow-y-auto">
          {orders.length === 0 ? (
            <div className="text-center text-gray-500 py-8">
              No active orders found.
            </div>
          ) : (
            orders.map((order) => {
              const details = getStatusDetails(order.status);
              const formattedDate = order.orderedAt?.toDate 
                ? order.orderedAt.toDate().toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric' })
                : "Unknown Date";

              return (
                <div key={order.id} className="border border-gray-100 rounded-xl p-4 shadow-sm bg-gray-50">
                  <div className="flex justify-between items-start mb-4">
                    <div>
                      <p className="text-xs text-gray-500 font-mono mb-1">ID: {order.id}</p>
                      <p className="text-sm font-medium text-gray-900">Quantity: {order.quantity}</p>
                      <p className="text-xs text-gray-500 mt-1">Date: {formattedDate}</p>
                    </div>
                    <div className={`flex items-center space-x-1.5 px-3 py-1 rounded-full text-xs font-medium ${details.bg} ${details.color}`}>
                      {details.icon}
                      <span>{details.label}</span>
                    </div>
                  </div>
                  
                  <div className="w-full bg-gray-200 rounded-full h-2 mt-4">
                    <div 
                      className="bg-blue-600 h-2 rounded-full transition-all duration-500" 
                      style={{ width: `${details.progress}%` }}
                    ></div>
                  </div>
                  
                  <div className="flex justify-between text-xs text-gray-400 mt-2">
                    <span>Ordered</span>
                    <span>Processing</span>
                    <span>Shipped</span>
                    <span>Delivered</span>
                  </div>
                </div>
              );
            })
          )}
        </div>

        <div className="pt-4 p-6 flex border-t border-gray-100 bg-white">
          <button
            onClick={onClose}
            className="w-full py-3 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrackOrderModal;
